import { copyTextToClipboard } from '@systemeio/ui'
import React from 'react'
import { Loader } from 'shared/components/loader'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import LinkIcon from 'shared/icons/link-icon'
import { getLocaleForLink } from 'shared/utils/locale/get-locale-for-link'

interface AffiliatePromotionLinkProps {
  affiliateId?: string
}

const AffiliateDashboardPromotionLink = ({ affiliateId }: AffiliatePromotionLinkProps) => {
  const { t } = useLocoTranslation()
  const { user } = useUser()

  const promotionLink = `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${
    process.env.NEXT_PUBLIC_SIO_HOST_NAME
  }${getLocaleForLink(user?.dashboardLocale)}?sa=${affiliateId}`

  return (
    <div
      className={
        'rounded-lg flex max-w-full items-center border border-gray/30 bg-lightblue/50 py-3 px-1.5'
      }
    >
      <button
        disabled={!affiliateId}
        onClick={async e => {
          e.preventDefault()
          await copyTextToClipboard(promotionLink, t('global.copy_clipboard'))
        }}
        className={
          'outline-none px-3 py-1 border-r border-gray/30 focus-visible:ring-2 ring-blue ring-offset-1'
        }
      >
        {affiliateId ? (
          <LinkIcon className="fill-blue w-[15px] sm:w-[20px] h-[15px] sm:h-[20px]" />
        ) : (
          <Loader small />
        )}
      </button>
      {affiliateId && <span className={'px-3 text-blue truncate'}>{promotionLink}</span>}
    </div>
  )
}

export default AffiliateDashboardPromotionLink
